import { apiDelete, apiGet, apiPost } from "./http";
import type { StoredNotification } from "../pages/admin/utils/notificationStore";

type BroadcastRow = {
  id: string;
  title: string;
  content: string;
  type: string;
  status: string;
  targetGroup: string;
  targetCount: number;
  readCount: number;
  createdAt: string;
  sentAt?: string;
  scheduledAt?: string;
  relatedFileId?: string;
  relatedActivityId?: string;
  relatedActivityTitle?: string;
};

/** 定向广播：仅 relatedFileId（会员 LegacyId）本人可见；游客隐藏。 */
export function broadcastVisibleToMember(n: StoredNotification, memberScope: string): boolean {
  const rid = n.relatedActivityId ?? "";
  if (rid.startsWith("feedback:")) {
    if (memberScope === "_guest") return false;
    return (n.relatedFileId ?? "") === memberScope;
  }
  if (rid.startsWith("lottery:")) {
    if (memberScope === "_guest") return false;
    return (n.relatedFileId ?? "") === memberScope;
  }
  if (rid.startsWith("enrollment:")) {
    if (memberScope === "_guest") return false;
    return (n.relatedFileId ?? "") === memberScope;
  }
  return true;
}

function rowToStored(r: BroadcastRow): StoredNotification {
  return {
    id: r.id,
    title: r.title,
    content: r.content,
    type: r.type as StoredNotification["type"],
    status: r.status as StoredNotification["status"],
    targetGroup: r.targetGroup as StoredNotification["targetGroup"],
    targetCount: r.targetCount,
    readCount: r.readCount,
    createdAt: r.createdAt,
    sentAt: r.sentAt,
    scheduledAt: r.scheduledAt,
    relatedFileId: r.relatedFileId,
    relatedActivityId: r.relatedActivityId,
    relatedActivityTitle: r.relatedActivityTitle,
  };
}

export type CreateBroadcastBody = {
  title: string;
  content: string;
  type?: string;
  status?: string;
  targetGroup?: string;
  targetCount: number;
  readCount: number;
  sentAt?: string;
  scheduledAt?: string;
  relatedFileId?: string;
  relatedActivityId?: string;
  relatedActivityTitle?: string;
};

export async function fetchTenantBroadcastNotifications(tenantLegacyId: string): Promise<StoredNotification[]> {
  const rows = await apiGet<BroadcastRow[]>(`/api/tenants/${encodeURIComponent(tenantLegacyId)}/broadcast-notifications`);
  return rows.map(rowToStored);
}

export async function createTenantBroadcastNotification(
  tenantLegacyId: string,
  body: CreateBroadcastBody,
): Promise<StoredNotification> {
  const row = await apiPost<BroadcastRow>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/broadcast-notifications`,
    body,
  );
  return rowToStored(row);
}

export async function deleteTenantBroadcastNotification(tenantLegacyId: string, notifLegacyId: string): Promise<void> {
  await apiDelete(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/broadcast-notifications/${encodeURIComponent(notifLegacyId)}`,
  );
}
